import { isJSON } from "~/composables/helpers/util";
import type { User } from "@/types";
const isClient = typeof window !== "undefined";

export function getJWTUser(): any {
  if (!isClient) return null;

  const pfUserStorage = localStorage.getItem("pfUser");
  if (pfUserStorage && isJSON(pfUserStorage)) {
    return JSON.parse(pfUserStorage);
  }
  return null;
}

export function getJWTUserToken(): string | null {
  if (!isClient) return null;

  const user = getJWTUser();
  return user?.token ?? null;
}

export function setJWTUser(user: User) {
  if (!isClient) return;

  if (user && typeof user === "object" && Object.keys(user).length > 0) {
    localStorage.setItem("pfUser", JSON.stringify(user));
  }
}

export function deleteJWTUser() {
  if (!isClient) return;

  localStorage.removeItem("pfUser");
}

export function getJWTToken(): string | null {
  if (!isClient) return null;

  const pfUserStorage = localStorage.getItem("pfUser");
  if (pfUserStorage) {
    try {
      const user: User = JSON.parse(pfUserStorage);
      return user?.token || "";
    } catch (error) {
      const notificationStore = useNotificationStore();
      notificationStore.error({
        variant: "error",
        messageHead: "Error parsing pfUser from localStorage",
        messageBody: String(error)
      });
      return "";
    }
  }
  return "";
}

export function authHeader(): { Authorization?: string } {
  if (!isClient) return {};

  const pfUserStorage = localStorage.getItem("pfUser");
  if (pfUserStorage) {
    const user: User = JSON.parse(pfUserStorage);
    if (user?.token) {
      return { Authorization: `Bearer ${user.token}` };
    }
  }
  return {};
}
